// Filtriranje liste po poljima, za blokove oglasa i dogadjaja (AdsBlock, EventsBlock).
// Stavka prolazi kad se sva polja iz filtera poklapaju:
//   - true / false: poredi se istinitost polja (npr. { top_event: false } propusta 0, null i nedostajuce polje)
//   - tekst: bez obzira na velika i mala slova
//   - broj: poredi se kao tekst (1 i "1" su isto)
export function filterByFields<T extends Record<string, any>>(items: T[] | null | undefined, filter: Record<string, any> = {}): T[] {
  const list = Array.isArray(items) ? items : []
  const rules = Object.entries(filter)
  if (!rules.length) return list

  const same = (actual: any, wanted: any) => {
    if (typeof wanted === 'boolean') return Boolean(actual) === wanted
    if (typeof wanted === 'string') return String(actual ?? '').toLowerCase() === wanted.toLowerCase()
    return String(actual) === String(wanted)
  }

  return list.filter((item) => rules.every(([key, wanted]) => same(item?.[key], wanted)))
}
